import { RementeLogo } from '@remente/shared-frontend';
import { Button } from '@remente/shared-frontend';
import { useTranslation } from 'react-i18next';

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <div className="flex w-full max-w-2xl flex-col items-center text-center">
        <RementeLogo />

        <div className="my-8">
          <h1 className="text-9xl font-bold text-(--color-fgMuted)">{t('not_found.error_code')}</h1>
        </div>

        <h2 className="mb-4 text-4xl font-bold text-(--color-fgDefault)">
          {t('not_found.title')}
        </h2>

        <p className="mb-8 text-lg text-(--color-fgMuted)">{t('not_found.message')}</p>

        <Button as="a" href="https://remente.com" variant="primary">
          {t('not_found.cta')}
        </Button>
      </div>
    </div>
  );
};
